"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeScreenshot = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
exports.takeScreenshot = (0, core_1.makeEndpoint)({
    method: "post",
    path: "/private/screenshot",
    alias: "takeScreenshot",
    parameters: [
        {
            name: "body",
            type: "Body",
            schema: zod_1.z.object({
                type: zod_1.z.enum(["html", "url"]),
                html: zod_1.z.string().optional(),
                url: zod_1.z.string().optional(),
                format: zod_1.z.enum(["png", "pdf"]).default("png"),
                delay: zod_1.z.number().optional().default(0),
                width: zod_1.z.number().optional().default(1920),
                height: zod_1.z.number().optional().default(1080),
                marginSize: zod_1.z.number().optional().default(30),
                hasAutoHeight: zod_1.z.boolean().optional().default(false),
            }),
        },
    ],
    response: zod_1.z.object({
        url: zod_1.z.string(),
    }),
});
//# sourceMappingURL=takeScreenshot.js.map